import { useCallback } from 'react';
import { LOCAL_ACCOUNTS_BASE_URL } from '../consts';
import { usePost, UsePostParams } from '../../../../api';

export type UnbindLocalAccountPayload = {};
export type UnbindLocalAccountResponse = never;
export type UnbindLocalAccountError = unknown;

export type UseUnbindLocalAccountParams = UsePostParams<
    UnbindLocalAccountPayload,
    UnbindLocalAccountResponse,
    UnbindLocalAccountError
>;

export const useUnbindLocalAccount = (params: UseUnbindLocalAccountParams = {}) => {
    const { post, ...rest } = usePost<UnbindLocalAccountPayload, UnbindLocalAccountResponse, UnbindLocalAccountError>(
        params
    );

    const unbindLocalAccount = useCallback(
        (localAccountGuid: string) => post(`${LOCAL_ACCOUNTS_BASE_URL}/${localAccountGuid}/unbind`, {}),
        [post]
    );

    return {
        ...rest,
        unbindLocalAccount
    };
};
